import * as angular from 'angular';
import {IController} from "angular";

export class DeliveryLinkCtrl implements IController {
  id: string;
  externalId: string;
  priorityId: string;
  showTooltip: boolean;

  public canCopy: boolean;
  private readonly displayExternal: any;
  private displayId: any;

  /* @ngInject */
  constructor(private splitService, private $state) {
    this.displayExternal = this.splitService.getSiteExternalIdConfig();
  }

  $onInit() {

    this.displayId = this.priorityId ? this.priorityId : (
      !this.externalId ?
        this.id :
        (this.displayExternal ? this.externalId : this.id)
    )
  }

  $onChanges(changes) {
    if (changes.id && !changes.id.isFirstChange() ||
      changes.externalId && !changes.externalId.isFirstChange()) {
      this.$onInit();
    }
  };

}

angular
  .module('bringoz.admin.deliveries')
  .component('deliveryLink', {
    bindings: {
      id: '<',
      externalId: '<?',
      priorityId: '<?',
      showTooltip: '<?',
    },
    template: require('./delivery-link.html').default,
    controller: DeliveryLinkCtrl
  });
